export default function Home() {
  return (
    <div className="bg-white shadow rounded-lg p-6">
      <h2 className="text-2xl font-semibold text-gray-900 mb-4">欢迎使用 TokNav</h2>
      <p className="text-gray-600 mb-4">
        TokNav 是一个现代化的书签管理工具，包含 Web 应用和浏览器扩展两个部分。基于 Vite + React + TypeScript 构建，提供了全面的书签管理功能。
      </p>

      <div className="space-y-6">
        <div>
          <h3 className="text-lg font-medium text-gray-900 mb-2">核心功能</h3>
          <ul className="list-disc list-inside space-y-2 text-gray-600">
            <li>书签添加与编辑：支持标题、URL、描述、分类和标签</li>
            <li>书签卡片的右键菜单功能：打开链接、显示链接二维码、复制链接</li>
            <li>多格式导入导出：支持 HTML、CSV、JSON 格式</li>
            <li>分类管理：支持多级分类结构</li>
            <li>标签系统：快速添加/删除标签</li>
            <li>全文搜索：多维度过滤</li>
            <li>具有验证书签有效性功能</li>
            <li>具有键盘快捷键功能</li>
            <li>具有收藏夹功能：快速收藏管理</li>
            <li>支持从浏览器导出的书签HTML文件导入</li>
            <li>浏览器扩展：便捷保存页面</li>
            <li>书签统计分析</li>
          </ul>
        </div>

        <div>
          <h3 className="text-lg font-medium text-gray-900 mb-2">技术特点</h3>
          <ul className="list-disc list-inside space-y-2 text-gray-600">
            <li>模块化设计：清晰的组件结构</li>
            <li>性能优化：支持大文件处理</li>
            <li>用户体验：友好的界面和快捷键</li>
            <li>数据安全：完善的错误处理</li>
          </ul>
        </div>
      </div>
    </div>
  )
}